import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { collection, onSnapshot } from "firebase/firestore";
import { db } from "../firebase"; // adjust path if needed

const Dashboard = () => {
  const navigate = useNavigate();

  const [stats, setStats] = useState({
    customers: null, // Change to null instead of 0 to indicate loading state
    orders: null,
    stores: null,
    revenue: null,
    storePerformance: {
      totalSales: null,
      avgRating: null,
      onTimeDeliveries: null,
    },
    customerPerformance: {
      totalSpend: null,
      avgRating: null,
    },
    deliveryPerformance: {
      totalDeliveries: null,
      avgDeliveryTime: null,
    },
  });

  // Fetching Data from Firebase
  useEffect(() => {
    const unsubOrders = onSnapshot(collection(db, "orders"), (snapshot) => {
      const orders = snapshot.docs.map((doc) => doc.data());
      const totalRevenue = orders.reduce((acc, order) => acc + (order.amount || 0), 0);
      const onTimeDeliveries = orders.filter(order => order.isDeliveredOnTime).length;

      setStats((prev) => ({
        ...prev,
        orders: orders.length,
        revenue: totalRevenue,
        storePerformance: {
          totalSales: orders.length,
          avgRating: orders.reduce((acc, order) => acc + (order.rating || 0), 0) / orders.length,
          onTimeDeliveries,
        }
      }));
    });

    const unsubCustomers = onSnapshot(collection(db, "customers"), (snapshot) => {
      const customers = snapshot.docs.map(doc => doc.data());
      const totalSpend = customers.reduce((acc, customer) => acc + (customer.totalSpent || 0), 0);
      const avgRating = customers.reduce((acc, customer) => acc + (customer.avgRating || 0), 0) / customers.length;
      
      setStats((prev) => ({
        ...prev,
        customers: snapshot.size,
        customerPerformance: {
          totalSpend,
          avgRating,
        }
      }));
    });

    const unsubStores = onSnapshot(collection(db, "stores"), (snapshot) => {
      setStats((prev) => ({ ...prev, stores: snapshot.size }));
    });

    const unsubDeliveryPartners = onSnapshot(collection(db, "deliveryPartners"), (snapshot) => {
      const totalDeliveries = snapshot.docs.length;
      const avgDeliveryTime = snapshot.docs.reduce((acc, doc) => acc + (doc.data().avgDeliveryTime || 0), 0) / totalDeliveries;
      
      setStats((prev) => ({
        ...prev,
        deliveryPerformance: {
          totalDeliveries,
          avgDeliveryTime,
        }
      }));
    });

    return () => {
      unsubOrders();
      unsubCustomers();
      unsubStores();
      unsubDeliveryPartners();
    };
  }, []);

  const cards = [
    { title: "Customers", value: stats.customers !== null ? stats.customers : "Loading...", route: "/customers" },
    { title: "Orders", value: stats.orders !== null ? stats.orders : "Loading...", route: "/orders" },
    { title: "Stores", value: stats.stores !== null ? stats.stores : "Loading...", route: "/stores" },
    { title: "Revenue", value: stats.revenue !== null ? `₹${stats.revenue.toFixed(2)}` : "Loading...", route: "/orders" }, // Showing formatted revenue
  ];

  return (
    <div style={{ padding: "20px" }}>
      <h2>Welcome to the FastStyle Admin Panel</h2>
      
      <div style={cardsContainer}>
        {cards.map((card) => (
          <div
            key={card.title}
            onClick={() => navigate(card.route)}
            style={cardStyle}
          >
            <h3 style={{ marginBottom: "10px" }}>{card.title}</h3>
            <p style={{ fontSize: "1.5rem", fontWeight: "bold" }}>{card.value}</p>
          </div>
        ))}
      </div>

      <div style={performanceContainer}>
        <h3>Performance Overview</h3>
        <div style={performanceCard}>
          <h4>Store Performance</h4>
          <p>Total Sales: {stats.storePerformance.totalSales !== null ? stats.storePerformance.totalSales : "Loading..."}</p>
          <p>Average Rating: {stats.storePerformance.avgRating !== null ? stats.storePerformance.avgRating.toFixed(2) : "Loading..."}</p>
          <p>On-time Deliveries: {stats.storePerformance.onTimeDeliveries !== null ? stats.storePerformance.onTimeDeliveries : "Loading..."}</p>
        </div>
        <div style={performanceCard}>
          <h4>Customer Performance</h4>
          <p>Total Spend: ₹{stats.customerPerformance.totalSpend !== null ? stats.customerPerformance.totalSpend.toFixed(2) : "Loading..."}</p>
          <p>Average Rating: {stats.customerPerformance.avgRating !== null ? stats.customerPerformance.avgRating.toFixed(2) : "Loading..."}</p>
        </div>
        <div style={performanceCard}>
          <h4>Delivery Partner Performance</h4>
          <p>Total Deliveries: {stats.deliveryPerformance.totalDeliveries !== null ? stats.deliveryPerformance.totalDeliveries : "Loading..."}</p>
          <p>Average Delivery Time: {stats.deliveryPerformance.avgDeliveryTime !== null ? stats.deliveryPerformance.avgDeliveryTime.toFixed(2) : "Loading..."} mins</p>
        </div>
      </div>
    </div>
  );
};

const cardsContainer = {
  display: "flex",
  flexWrap: "wrap",
  gap: "20px",
  marginTop: "20px",
};

const cardStyle = {
  flex: "1 1 200px",
  backgroundColor: "#f0f0f0",
  padding: "20px",
  borderRadius: "12px",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
  cursor: "pointer",
  transition: "transform 0.2s",
  textAlign: "center",
};

const performanceContainer = {
  marginTop: "40px",
  display: "flex",
  flexDirection: "column",
  gap: "20px",
};

const performanceCard = {
  backgroundColor: "#f9f9f9",
  padding: "20px",
  borderRadius: "12px",
  boxShadow: "0 2px 6px rgba(0, 0, 0, 0.1)",
  textAlign: "left",
};

export default Dashboard;
